/**
 * Increment when {@link migrateRequiredPanels} logic changes so persisted configs without a matching
 * version re-run the migration.
 */
export const PREVIOUSLY_REQUIRED_TRADING_PANELS_MIGRATION_VERSION = 1;

/** Run when stored version is missing or below the current migration version. */
export function shouldRunRequiredPanelsMigration(config: { requiredPanelsMigrationVersion?: number }): boolean {
  const v = config.requiredPanelsMigrationVersion;
  return v == null || v < PREVIOUSLY_REQUIRED_TRADING_PANELS_MIGRATION_VERSION;
}
